import { useRef, memo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';
import { CharacterPlaceholder } from './characters/CharacterPlaceholder';
import { HealthBar } from './ui/HealthBar';

export const RemotePlayer = memo(({ player }: { player: any }) => {
    const mesh = useRef<THREE.Group>(null);
    const prevPos = useRef(new THREE.Vector3(player.x, player.y, player.z));
    const targetPos = useRef(new THREE.Vector3(player.x, player.y, player.z));
    const animState = useRef('idle');

    useFrame((_, delta) => {
        if (!mesh.current || !player) return;

        targetPos.current.set(player.x, player.y, player.z);

        const dist = mesh.current.position.distanceTo(targetPos.current);
        const movedDist = mesh.current.position.distanceTo(prevPos.current);
        const speed = movedDist / delta;
        const positionAlpha = 1 - Math.exp(-12 * delta);
        const rotationAlpha = 1 - Math.exp(-16 * delta);

        animState.current = speed > 0.5 ? 'run' : 'idle';

        if (player.rx !== undefined) {
            mesh.current.rotation.y = THREE.MathUtils.lerp(mesh.current.rotation.y, player.rx, rotationAlpha);
        } else if (dist > 0.1) {
            mesh.current.lookAt(targetPos.current.x, targetPos.current.y + mesh.current.position.y - player.y, targetPos.current.z);
        }

        mesh.current.position.lerp(targetPos.current, positionAlpha);
        prevPos.current.copy(mesh.current.position);
    });

    return (
        <group ref={mesh} position={[player.x, player.y, player.z]}>
            <HealthBar hp={player.hp || 100} maxHp={player.maxHp || 100} offset={[0, 2.2, 0]} />

            <CharacterPlaceholder
                theme="cyberpunk"
                animation={animState.current}
            />
            {/* Simple Floating Name/ID */}
            <mesh position={[0, 1.8, 0]}>
                <sphereGeometry args={[0.05, 8, 8]} />
                <meshBasicMaterial color="lime" />
            </mesh>
        </group>
    );
});
